import { RefObject, useEffect, useState } from 'react';

const SCROLL_TARGET_ID = 'scrollTarget';
const DEFAULT_ROOT_MARGIN = '100px';

interface Options {
  rootMargin?: string;
  disabled?: boolean;
}

export function useInViewport(
  ref: RefObject<Element | null>,
  { rootMargin = DEFAULT_ROOT_MARGIN, disabled = false }: Options = {}
) {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    if (disabled) {
      setIsInView(false);
      return;
    }

    const element = ref.current;
    const root = document.getElementById(SCROLL_TARGET_ID);

    if (!element || !root) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      { root, rootMargin }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [disabled, ref, rootMargin]);

  return isInView;
}
